import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  height: 380px;
  display: flex;
  flex-direction: column;
`;

const Navigation = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 60px;
  justify-content: space-between;
  width: 100%;
`;

const Tab = styled.button.attrs({
  type: 'button'
})`
  background-color: transparent;
  border: 1px solid ${colors.g02};
  color: ${props => (props.active ? colors.g05 : colors.g03)}
  cursor: pointer;
  flex: 1;
  font-weight: 700;
  height: 60px;

  &:first-child {
    border-top-left-radius: 16px;
  }

  &:last-child {
    border-top-right-radius: 16px;
    border-left: 0;
  }

  &:focus {
    outline: none;
  }
`;

function Tabs({ activeIndex, onTabChange, children }) {
  const childrenArray = React.Children.toArray(children);
  const activeElement = childrenArray[activeIndex];

  return (
    <Container>
      <Navigation>
        {childrenArray.map((element, index) => {
          const id = `tabs-${index}`;

          return (
            <Tab active={index === activeIndex} key={id} onClick={() => onTabChange(index)}>
              {element && element.props && element.props.title}
            </Tab>
          );
        })}
      </Navigation>

      <Content>{activeElement && activeElement.props && activeElement.props.children}</Content>
    </Container>
  );
}

Tabs.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

Tabs.Tab = ({ children }) => children;

export { Tabs };
